import { SVGProps } from 'react';

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    {...props}
  >
    <g clipPath="url(#clip0_163503_19185)">
      <circle
        cx="9"
        cy="9"
        r="5.25"
        stroke="#686D7E"
        strokeWidth="1.5"
      ></circle>
    </g>
    <defs>
      <clipPath id="clip0_163503_19185">
        <path fill="#fff" d="M3 3h12v12H3z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default SvgIcon;
